import { createThunk, ListModel, model } from 'mst-collection';
import { castToSnapshot, getRoot, types } from 'mobx-state-tree';

import { TutorialModel } from './TutorialModel';
import { Api, schemas } from '@api';
import { handleFlow, shouldRejectPagination } from '../utils';
import type { RootModelType } from '../RootModel';

export class TutorialList extends ListModel(
  types.reference(TutorialModel),
  {
    idAttribute: 'id',
    schema: schemas.TutorialListSchema,
    pageSize: 30,
  },
) {
  private get _filterCategoryIds(): number[] {
    const ids =
      getRoot<RootModelType>(this).tutorial.categories
        .appliedFilterIds;

    // When we want to fetch all tutorials we need to pass 0 in array which means
    // all tutorials
    return ids.length === 0 ? [0] : ids;
  }

  private get _filterTagIds(): number[] {
    const ids =
      getRoot<RootModelType>(this).tags.recommended.appliedTagIds;

    // When we want to fetch all tutorials we need to pass 0 in array which means
    // all tutorials
    return ids.length === 0 ? [0] : ids;
  }

  get hasActiveFilter(): boolean {
    return (
      getRoot<RootModelType>(this).tutorial.categories
        .appliedFilterIds.length > 0
    );
  }

  fetch = createThunk(() => {
    return async function fetch(this: TutorialList) {
      const res = await Api.Hub.getTutorials({
        count: this.pageSize,
        start: 0,
        categoryIds: this._filterCategoryIds,
        tagIds: this._filterTagIds,
      });

      this.set(res.data.videos);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: TutorialList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Hub.getTutorials({
          count: this.pageSize,
          start: this.offset,
          categoryIds: this._filterCategoryIds,
          tagIds: this._filterTagIds,
        });

        this.append(castToSnapshot(res.data.videos));
      });
    };
  }, false);
}

export const TutorialListModel = model(TutorialList);
